import CheckmarkOrb from '@clearkit/icons/glyphs/CheckmarkOrb';
import { CKBox, CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

function UpgradeAccountComplete({ email, backPath }) {
  return (
    <div className="p-6">
      <CKBox>
        <header className="p-6 text-center">
          <CheckmarkOrb
            className="m-auto mb-3 fill-gradient-br-green display-inline"
            height={36}
            width={36}
          />
          <h1 className="mb-2 text-lg font-semibold">
            Thank you for contacting our success team
          </h1>
          <p>
            Our team will be reaching out to you at{' '}
            <span className="font-medium">{email}</span> as soon as possible
            with information on upgrading your Clearbit plan.
          </p>
        </header>

        <footer className="flex justify-center p-6 border-t border-gray-200">
          <CKButton as={Link} to={backPath} variant="bold" variantColor="blue">
            Dismiss
          </CKButton>
        </footer>
      </CKBox>
    </div>
  );
}

UpgradeAccountComplete.propTypes = {
  email: PropTypes.string.isRequired,
  backPath: PropTypes.string,
};

export default UpgradeAccountComplete;
